import { Component, OnInit, AfterViewInit } from '@angular/core'
import { AuthService, TranslationService, User } from '@spartacus/core'
import { Observable } from 'rxjs'
import { ContactusService } from '../contactus.service'
import { MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute } from '@angular/router'
import { BreadcrumbService } from '../../../shared/components/breadcrumb/breadcrumb.service'

@Component({
  standalone: false,
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.scss'],
})
export class ContactusComponent implements OnInit, AfterViewInit {
  contactus: any[] = []
  channelPartners: any[] = []
  displaycontact: string
  searchText: string
  isShowAll = true
  isDesc = false
  column: string
  displayedColumns: string[] = [
    'productLine',
    'region',
    'salesArea',
    'email',
    'phoneNum',
    'workingHours',
  ]
  dataSource = new MatTableDataSource(this.contactus)
  user$: Observable<User>
  loggedIn = false
  userType: string
  fromPage: string
  isChannelPartner = false

  constructor(
    private contactservice: ContactusService,
    private breadCrumbService: BreadcrumbService,
    public auth: AuthService,
    private translate: TranslationService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((params: any) => {
      this.fromPage = params?.page
    })

    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        this.loggedIn = success
        if (this.loggedIn) {
          this.userType = 'current'
        }
        if (!this.loggedIn) {
          this.userType = 'anonymous'
        }

        this.contactservice.getcontacts(this.userType, false).subscribe(
          (contactdata: any[]) => {
            this.contactus = contactdata
            this.dataSource.data = this.contactus
          },
          (error) => {}
        )

        if (this.loggedIn) {
          this.contactservice.isChannelPartners(this.userType).subscribe(
            (isChannelPartner: boolean) => {
              this.isChannelPartner = isChannelPartner
            },
            (error) => {}
          )
          this.contactservice.getChannelPartners(this.userType).subscribe(
            (data: any) => {
              this.channelPartners = data.channelPartners
            },
            (error) => {}
          )
        }
      },
      (error) => {
        this.loggedIn = false
        this.userType = 'anonymous'
      }
    )
  }

  ngOnInit() {
    this.breadCrumbService.setBreadCrumbs([])
    this.translate
      .translate('contactusform.contactUs')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )
    this.displaycontact = 'collapse'
  }

  ngAfterViewInit() {
    this.dataSource.data = this.contactus
  }

  // view all click event
  viewAll() {
    this.contactservice.getcontacts(this.userType, true).subscribe(
      (contactdata: any[]) => {
        this.contactus = contactdata
        this.dataSource.data = this.contactus
        this.isShowAll = !this.isShowAll
      },
      (error) => {}
    )
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  // sorting the property on click of icon
  sortContact(property) {
    this.isDesc = !this.isDesc // change the direction
    this.column = property
    const direction = this.isDesc ? 1 : -1
    this.dataSource.data = this.contactus
    this.contactus.sort((a, b) => {
      if (a[property] < b[property]) {
        return -1 * direction
      } else if (a[property] > b[property]) {
        return 1 * direction
      } else {
        return 0
      }
    })
  }
}
